import { Heading } from '@americanexpress/dls-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function Disclaimer() {
  return (
    <>
      <Heading level={3} variant="sans-medium-bold" className="margin-2-b">
        <FormattedMessage id="view-all.disclaimer.title" defaultMessage="Disclaimer" />
      </Heading>
      <section className="margin-0 flex text-wrap">
        <FormattedMessage
          id="view-all.disclaimer.disclaimer"
          defaultMessage={'&#8224;Your Card may have additional benefits'
            + ' not listed above. If you have purchased additional benefits, '
            + 'please call the number on the back of your Card for more '
            + 'information. Benefit coverage and eligibility may vary '
            + 'for Additional Card Members.'}
        />
      </section>
    </>
  );
}
